/**
 * 秒 → 労働可能時間の短縮表記（`15h` / `15h30m`）。
 *
 * 0 / undefined / null / 負値は空文字を返す。呼び出し側は空文字なら
 * 区切り文字ごと出さない（「・」だけが残るのを防ぐため）。
 *
 * Why not numberDecorator.convertToHoursAndMinutes: あちらは `15時間` / `1時間30分` の
 * 日本語書式を返す。車両リストは横幅が厳しく、依頼文も英字表記（`・10h`）を指定している。
 */
export function formatLaborHours(seconds: number | undefined | null): string {
  if (!seconds || seconds <= 0) return '';
  const mins = Math.floor(seconds / 60);
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m === 0 ? `${h}h` : `${h}h${m}m`;
}
